import { LeadsCustomFilterCounts } from './customFilterCounts.dto';
import { Lead } from './lead';

export class GetLeadsResponse {
  leads?: Lead[];
  totalCount: number;
  customFilterCounts: LeadsCustomFilterCounts;

  constructor(leads: Lead[], totalCount: number, customFilterCounts?: LeadsCustomFilterCounts) {
    this.leads = leads;
    this.totalCount = totalCount;

    if (customFilterCounts) {

      this.customFilterCounts = new LeadsCustomFilterCounts(customFilterCounts);
    }
  }
}
